const $ = window.jQuery;
import _ from 'lodash';

import { getUrlParameter } from '../utilities';

$(() => {
    const $selects = $('.aam__select');

    if (!$selects.length) {
        return;
    }

    _.each($selects, select => {
        const $select = $(select);
        const $placeholder = $select.find('.aam__select-placeholder').first();
        const placeholder_text = $select.attr('data-placeholder');
        const $input = $select.find('.aam__select-input').first();
        const $options = $select.find('.aam__select-options').first();
        const $list_items = $select.find('.aam__select-options-list-item');
        const name = $input.attr('name');
        const query_val = getUrlParameter(name);

        if (query_val) {
            const label = $input
                .find(`option[value="${query_val}"]`)
                .text()
                .trim();
            const prepend = $input.attr('name') === 'sort' ? 'Sort By ' : '';
            $placeholder.html(prepend + label);
            $input.val(query_val);
        }

        $options.attr(
            'data-max-height',
            $options
                .find('.aam__select-options-list')
                .first()
                .outerHeight(true),
        );

        let optionsOpen = false;

        $select.on('update-height', () =>
            $options.attr(
                'data-max-height',
                $options
                    .find('.aam__select-options-list')
                    .first()
                    .outerHeight(true),
            ),
        );

        $select.on('reset', () => {
            if (optionsOpen) {
                const maxHeight = $options.attr('data-max-height');
                const transition = `max-height ${maxHeight *
                    2}ms cubic-bezier(0.785, 0.135, 0.15, 0.86)`;
                $options.css({ transition, maxHeight: 0 });
                optionsOpen = false;
                setTimeout(
                    () => $select.removeClass('aam__select--expanded'),
                    maxHeight * 2.5,
                );
            }
        });

        $select.on('click', e => {
            if( $(e.target).is('select') ) {
                return;
            }

            if ($('.aam__select--expanded').length && !optionsOpen) {
                $('.aam__select--expanded')[0].click();
            }

            const maxHeight = $options.attr('data-max-height');
            const transition = `max-height ${maxHeight *
                2}ms cubic-bezier(0.785, 0.135, 0.15, 0.86)`;

            if (optionsOpen) {
                $options.css({ transition, maxHeight: 0 });
                optionsOpen = false;
                setTimeout(
                    () => $select.removeClass('aam__select--expanded'),
                    maxHeight * 2.5,
                );
            } else {
                $options.css({ transition, maxHeight: `${maxHeight}px` });
                $select.addClass('aam__select--expanded');
                optionsOpen = true;
            }
        });

        $list_items.on('click', function(e) {
            const text = $(this)
                .text()
                .trim();
            const value = $(this).attr('data-value');
            const prepend = $input.attr('name') === 'sort' ? 'Sort By ' : '';
            $placeholder.html(value ? prepend + text : placeholder_text);
            $input.val(value);
            $input.trigger('change');
        });

        $(window).on(
            'resize',
            _.throttle(() => {
                $options.attr(
                    'data-max-height',
                    $options
                        .find('.aam__select-options-list')
                        .first()
                        .outerHeight(true),
                );
            }, 150),
        );
    });
});
